import { render } from "./watchlist.vue?vue&type=template&id=16049fb3&scoped=true"
import script from "./watchlist.vue?vue&type=script&lang=js"
export * from "./watchlist.vue?vue&type=script&lang=js"

import "./watchlist.vue?vue&type=style&index=0&id=16049fb3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16049fb3"]])

export default __exports__